// extracted by mini-css-extract-plugin
export var container = "_6s-0";